import SPENDING_CATEGORIES from '../definitions/SpendingCategories';
import DEFAULT_CARD_PREFERENCES from '../definitions/DefaultCardPreferences';
import getSumOfObjectValues from './getSumOfObjectValues';


/**
 * Gets the monthlySpending values based on a new monthlySpendingAverage.
 * If every value in the monthlySpending object is NaN or 0, return the default
 * values from DEFAULT_CARD_PREFERENCES.monthlySpending.
 * If monthlySpendingAverage is undefined, we return undefined. (At the moment this happens on
 * CC product lists that do not have a monthlySpendingAverage filter.)
 * @param {(number|string)} monthlySpendingAverage - The new monthly spending average.
 * @param {MonthlySpendingCategories} [monthlySpendingCategories] - contains monthly spending values for each spending category.
 * @returns {(MonthlySpendingCategories|undefined)} - The updated monthly spending object.
 */
function getMonthlySpendingFromAverage(monthlySpendingAverage, monthlySpendingCategories) {
    const numericSpendingAverage = parseInt(monthlySpendingAverage);

    if (!Number.isFinite(numericSpendingAverage)) {
        return undefined;
    }

    let updatedMonthlySpending = {};

    // If all values are 0 or NaN, use the default values to generate the ratio from numericSpendingAverage
    if (
        !monthlySpendingCategories
        || Object.values(monthlySpendingCategories).every(val => isNaN(val) || val === 0)
    ) {
        updatedMonthlySpending = { ...DEFAULT_CARD_PREFERENCES.monthlySpending };
    } else {
        updatedMonthlySpending = { ...monthlySpendingCategories };
    }

    // Calculate the portion needed to convert the numericSpendingAverage to the new average
    const proportion = numericSpendingAverage / getSumOfObjectValues(updatedMonthlySpending);

    // Calculate the new monthlySpendingCategories values by multiplying categories proportionally to new average
    Object.keys(updatedMonthlySpending).forEach(key => {
        updatedMonthlySpending[key] = Math.round(updatedMonthlySpending[key] * proportion) || 0;
    });

    // Add any remainders from ratio calculation to the OTHER category
    updatedMonthlySpending[SPENDING_CATEGORIES.OTHER]
        += numericSpendingAverage - getSumOfObjectValues(updatedMonthlySpending);

    return updatedMonthlySpending;
}

export default getMonthlySpendingFromAverage;
